// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".segment-detail .nav-tabs{border:unset !important}.segment-detail .nav-tabs .nav-link{border:unset;color:gray}.segment-detail .nav-tabs .nav-link.active{color:#212529}.segment-detail .tab-content .content-box{border:unset !important}\n", ""]);
// Exports
module.exports = exports;
